import React, { useState, useRef, useEffect } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

const ReadMore = ({ children, maxHeight = "120px", multiChildrenView, ...props}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [fullHeight, setFullHeight] = useState("auto");
  let expandedContent;
  let collapsedContent;
  if(multiChildrenView){
     expandedContent = props?.expandedContent;
     collapsedContent = props?.collapsedContent;
  }
  const contentRef = useRef(null);
  console.log("is expanded", isExpanded)
  
  useEffect(() => {
    if (contentRef.current) {
      setFullHeight(multiChildrenView ? '1800px' : `${contentRef.current.scrollHeight}px`);
    }
  }, [children]);

  useEffect(() => {
    if(!isExpanded) {
    window.scrollBy({
      top: -parseFloat(maxHeight),
      behavior: "smooth"
    });
  }
  }, [isExpanded]);

  return (
    <div className="readmore-wrapper" style={{ width: '100%', marginBottom: '15px' }}>
      <div 
        className="readmore" 
        style={{
          maxHeight: isExpanded ? fullHeight : maxHeight,
          overflow: "hidden",
          transition: "max-height 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
          position: "relative",
          width: '100%',
        }}
      >
        <div ref={contentRef}>
          {(multiChildrenView ? (isExpanded ? expandedContent: collapsedContent): children)}
        </div>
        
        {/* BLURRED FADE OVERLAY: Only visible when collapsed */}
        {!isExpanded && (
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '25px', // Increased height for better blur transition
            // Gradient + Blur effect
            background: 'linear-gradient(to bottom, rgba(245, 247, 250, 0) 0%, rgba(245, 247, 250, 0.39) 50%, rgba(245, 247, 250, 0.61) 100%)',
            // backdropFilter: 'blur(0px)', // This creates the blurry text effect
            WebkitBackdropFilter: 'blur(2px)', // For Safari support
            pointerEvents: 'none',
            zIndex: 1
          }} />
        )}
      </div>

      {/* Centered Button Container */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        marginTop: '15px',
        lineHeight: "0.5rem"
      }}>
        <div 
          onClick={() => setIsExpanded(!isExpanded)} 
          style={{
            color: "#0a58ca",
            fontWeight: "700",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            fontSize: "16px",
            transition: "all 0.3s ease",
            padding: '10px 20px',
            zIndex: 2 // Keep button above the blur
          }}
          className="readmore-btn-hover"
        >
          <span>{isExpanded ? "Read Less" : "Read More"}</span>
          <div style={{ marginTop: '4px' }}>
            {isExpanded ? <UpOutlined /> : <DownOutlined />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadMore;